"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function useUniqueId(preferredId, prefix) {
  var memoKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _react.useMemo)(function () {
    return preferredId || (0, _uniqueId.default)(prefix);
  }, [preferredId, prefix].concat(_toConsumableArray(memoKeys)));
}

var _default = useUniqueId;
exports.default = _default;